import React from "react";
import PropTypes from "prop-types";

const CrossSquashed = ({ className, color }) => (
  <svg className={className} viewBox="0 0 30 22">
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    >
      <g
        transform="translate(-1213.000000, -52.000000)"
        stroke="#EF5518"
        strokeWidth="3"
      >
        <g transform="translate(1215.000000, 54.000000)">
          <line
            x1="1"
            y1="17"
            x2="25"
            y2="1"
            id="Line"
            transform="translate(13.000000, 9.000000) rotate(-1.309932) translate(-13.000000, -9.000000) "
          ></line>
          <line x1="1" y1="1" x2="24.674906" y2="17.4694998" id="Line"></line>
        </g>
      </g>
    </g>
  </svg>
);

CrossSquashed.defaultProps = {
  className: ``,
  color: `black`
};

CrossSquashed.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default CrossSquashed;
